<div class="sidebar" [class.expanded]="isExpanded" [class.mobile-open]="mobileOpen">
  <div class="sidebar-logo cursor-pointer" (dblclick)="onDblClickLogo()">
    <img [class]="sidebarLogoClassName" [src]="sidebarLogoSrc" alt="logo" />
  </div>

  <nav class="sidebar-navigation">
    @for (tab of TABS; track tab) {
      @if (tab.access) {
        <a
          class="sidebar-content"
          [routerLink]="tab.routerLink"
          [routerLinkActive]="['is-active']"
          [tuiHint]="isExpanded || mobileOpen ? '' : (tab.title | translate)"
          tuiHintDirection="right"
          (click)="navigationSelected.emit()"
        >
          <tui-icon [icon]="tab.iconSrc" class="icon" />
          <div class="text-container">
            <span class="text">{{ tab.title | translate }}</span>
          </div>
        </a>
      }
    }
  </nav>

  <div
    class="sidebar-settings"
    [tuiHint]="isExpanded || isOpenedSettings ? '' : ('Settings' | translate)"
    tuiHintDirection="right"
  >
    <div
      tuiDropdownOpen
      (tuiDropdownOpenChange)="isOpenedSettings = $event"
      [tuiDropdown]="content"
      tuiDropdownAlign="right"
      [tuiDropdownSided]="!mobileOpen"
    >
      <div class="sidebar-content">
        <tui-icon [icon]="'common/assets/icons/settings.svg'" class="transition" />

        <div class="text-container">
          <span class="text">{{ 'Settings' | translate }}</span>
        </div>
      </div>
    </div>

    <ng-template #content>
      <app-settings-tooltip [isDarkTheme]="true" />
    </ng-template>
  </div>

  <div class="sidebar-switcher">
    <div
      class="sidebar-content"
      (click)="setIsExpanded(!isExpanded)"
      [tuiHint]="(isExpanded ? '' : 'Expand') | translate"
    >
      <tui-icon
        [icon]="'common/assets/icons/arrow.svg'"
        class="transition"
        [class.left]="isExpanded"
        [class.right]="!isExpanded"
      />

      <div class="text-container">
        <span class="text">{{ 'Collapse' | translate }}</span>
      </div>
    </div>
  </div>
</div>
